import { render, staticRenderFns } from "./LaTen.vue?vue&type=template&id=293457a5&scoped=true&"
import script from "./LaTen.vue?vue&type=script&lang=js&"
export * from "./LaTen.vue?vue&type=script&lang=js&"
import style0 from "./LaTen.vue?vue&type=style&index=0&id=293457a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293457a5",
  null
  
)

export default component.exports